<template>
	<div class="header">
		<el-dropdown @command="handleExportCommand">
			<el-button type="warning" style="margin-right: 20px;">
				快速导出<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item command="today">导出今日</el-dropdown-item>
				<el-dropdown-item command="dateRange">选择日期</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<span class="header-name">{{ getDetailedGreeting().greeting }}，{{ username }}</span>
		<el-dialog title="选择日期范围" :visible.sync="dateRangeDialogVisible" width="30%">
			<el-date-picker v-model="exportDateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%">
			</el-date-picker>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dateRangeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="exportByDateRange">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';
	export default {
		name: 'AppHeader',
		data() {
			return {
				activeIndex: "1",
				username: JSON.parse(localStorage.getItem('token')).username || '未登录',
				dateRangeDialogVisible: false, // 日期范围对话框显示状态
				exportDateRange: [], // 导出的日期范围
			};
		},
		mounted() {
			console.log("login", JSON.parse(localStorage.getItem('token')))
		},
		methods: {
			handleSelect(key) {
				switch (key) {
					case 'user-change-password':
						this.$router.push('reset-password');
						break;
					case 'user-logout':
						this.$store.commit('setLoggedIn', false);
						this.$router.push('/login');
						break;
					default:
						console.log(`点击了菜单项: ${key}`);
				}
			},
			getDetailedGreeting() {
				const hour = new Date().getHours();
				let greeting = '';
				let period = '';

				if (hour >= 5 && hour < 9) {
					greeting = '早上好';
					period = '清晨';
				} else if (hour >= 9 && hour < 12) {
					greeting = '上午好';
					period = '上午';
				} else if (hour >= 12 && hour < 14) {
					greeting = '中午好';
					period = '中午';
				} else if (hour >= 14 && hour < 18) {
					greeting = '下午好';
					period = '下午';
				} else if (hour >= 18 && hour < 24) {
					greeting = '晚上好';
					period = '晚上';
				} else {
					greeting = '夜深了';
					period = '深夜';
				}

				return {
					greeting,
					period
				};
			},
			handleExportCommand(command) {
				switch (command) {
					case 'today':
						this.exportToday();
						break;
					case 'dateRange':
						this.showDateRangeDialog();
						break;
				}
			},

			// 导出今日数据
			async exportToday() {
				this.loading = true;
				const response = await fetch(`${apiBaseUrl}/exportAll.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						action: 'export_all',
						type: 'today'
					}),
				})
				const data = await response.json();
				console.log(data)
				// .then(response => response.json())
				// .then(data => {
				if (data.success) {
					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = data.download_url;
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.loading = false;
					this.$message.success(`成功导出 ${data.count} 条数据`);
				} else {
					this.loading = false;
					this.$message.error(data.message);
				}
			},

			// 显示日期范围选择对话框
			showDateRangeDialog() {
				this.dateRangeDialogVisible = true;
			},

			// 按日期范围导出
			async exportByDateRange() {
				if (!this.exportDateRange || this.exportDateRange.length !== 2) {
					this.$message.warning('请选择完整的日期范围');
					return;
				}

				const [startDate, endDate] = this.exportDateRange;

				this.loading = true;
				const response = await fetch(`${apiBaseUrl}/exportAll.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						action: 'export_all',
						type: 'date_range',
						start_date: startDate,
						end_date: endDate
					}),
				})
				const data = await response.json();
				console.log(data)
				// .then(response => response.json())
				// .then(data => {
				if (data.success) {
					// 创建隐藏的下载链接并触发点击
					const link = document.createElement('a');
					link.href = data.download_url;
					link.download = '';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.loading = false;
					this.$message.success(`成功导出 ${data.count} 条数据`);
				} else {
					this.loading = false;
					this.$message.error(data.message);
				}
			},
		}
	};
</script>

<style scoped>
	.header {
		padding: 0px;
		display: flex;
		align-items: center;
		height: 80px;
		justify-content: right;
		color: #666;
		background-color: #fff;
		padding: 0px 20px;
	}

	.logo-container {
		margin-right: 20px;
	}

	/deep/ .el-header {
		padding: 0px !important;
	}

	/deep/ .el-menu.el-menu--horizontal {
		border-bottom: none;
	}

	.el-menu-demo {
		width: 100%;
	}
</style>